import axios from "axios";

export const API = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})


export default {
    async submit_order(email, country, cable, antenna, notes, quantity, shipping, unit_price, shipping_cost, total_price) {
        return await API.post('order', {email: email, country: country,
            cable: cable, antenna: antenna, notes: notes, quantity: Number(quantity),
            shipping: shipping, unit_price: unit_price, shipping_cost: shipping_cost, total_price: total_price})
    },
    async contact(email, subject, notes) {
        return await API.post('contact', {email: email, subject: subject, notes: notes})
    },
    async get_shipping_rates(country, quantity, unit_price) {
        return await API.get('shipping_rates', {params: {country: country, quantity: quantity, unit_price: unit_price}})
    },
    async get_prices() {
        return await API.get('prices')
    }
}
